import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

export const getProduct = createAsyncThunk('product/getProduct', async data => {
  try {
    const response = await fetch('https://api.mobrespos.com/get_image', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        Accept: 'application/json',
      },
    });
    const productResponse = await response.json();
    // console.log('productResponse', productResponse);
    return productResponse;
  } catch (error) {
    console.log('product thunk hatası ' + error);
  }
});

export const productSlice = createSlice({
  name: 'products',
  initialState: {
    product: [],
    isLoading: false,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getProduct.pending, state => {
        state.isLoading = true;
      })
      .addCase(getProduct.fulfilled, (state, action) => {
        state.product = action.payload;
        state.isLoading = false;
      })
      .addCase(getProduct.rejected, state => {
        state.isLoading = false;
      });
  },
});

export default productSlice.reducer;
